export const isStaging = process.env.REACT_APP_VOLABY_ENVIRONMENT && process.env.REACT_APP_VOLABY_ENVIRONMENT === 'staging';
